module.exports = __webpack_public_path__ + "img/calendar.73185a30.svg";